var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('common-header'),(_vm.isRouterAlive)?_c('router-view',{key:_vm.$route.query.t}):_vm._e(),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }